
import { Factcheck, ShortLink } from "@/types";
import { Component, Vue } from "vue-property-decorator";

import { GetFactCheck, UpdateFactcheck } from "@/services/FactCheckService";
import { ListShortLinksForFactcheck } from "@/services/ShortServices";
import { useClipboard } from "@vueuse/core";
import { ROOT_ACTIONS } from "@/store/actions";

@Component({
  components: {
    EditSingleArticleSection: () =>
      import("@/components/EditSingleArticleSection.vue"),
    SingleArticleStatsSection: () =>
      import("@/components/SingleArticleStatsSection.vue"),
    CreateNewShortLinkDialog: () =>
      import("@/components/dialogs/CreateNewShortLinkDialog.vue"),
  },
})
export default class SingleArticleOverview extends Vue {
  tab = 0;

  dialogs = {
    datePicker: false,
    createArticle: false,
    newCategory: false,
    newShortLink: false,
  };

  article = null as Factcheck | null;
  shortLinks = [] as Array<{ shortLink: ShortLink; interactions: any[] }>;

  copyToClipboard(text: string) {
    const { copy } = useClipboard();
    copy(text);
    this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
      color: "success",
      text: "Link gekopieerd naar klembord",
    });
  }

  async mounted() {
    await this.fetchFactcheck();
    await this.fetchShortLinks();
  }

  async togglePublished() {
    if (this.article) {
      await UpdateFactcheck({
        id: this.article.id,
        isPublished: this.article.isPublished,
      });
    }
  }

  async fetchFactcheck() {
    const a = await GetFactCheck(this.$route.params.id);
    if (!a) {
      this.$router.push("/error?code=404");
      return;
    }
    if (!a.Claim) {
      this.$router.push("/error?code=404");
      return;
    }
    // if Claims.ClaimSources[*].date is an ISO string, convert to first 10 chars, beware of null values
    if (a.Claim.ClaimSources && Array.isArray(a.Claim.ClaimSources)) {
      a.Claim.ClaimSources = a.Claim.ClaimSources.map(source => ({
        ...source,
        date: typeof source.date === 'string' 
          ? source.date.slice(0, 10)
          : source.date ?? null
      }));
    }
    this.article = await GetFactCheck(this.$route.params.id);
    if (this.article === null) {
      this.$router.push("/error?code=404");
    }
  }

  async fetchShortLinks() {
    this.shortLinks = await ListShortLinksForFactcheck(
      this.article!.id as string
    );
  }
}
